import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";

export class RelatedUsersApi {
  getBaseEndpoint(letterFileId: number) {
    return `letter-file/${letterFileId}/related-users/`;
  }

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  async isRelated(lfId: number, mail: string): Promise<boolean> {
    const response = await this.network.get<boolean>(`${this.getBaseEndpoint(lfId)}is-related`, { mail });
    return response.data;
  }
}

export const [relatedUsersApiToken, useRelatedUsersApi] = useClassFactory(RelatedUsersApi);
